import { useState } from 'react';
import { ClipboardList, Settings2 } from 'lucide-react';
import { AdminDailyUpdate } from './AdminDailyUpdate';
import { AdminSettings } from './AdminSettings';
import { C } from './utils';

export const AdminConsole = ({ canConfigure, isCoreAdmin, access, employees, settings, onChanged, onAfterClose }) => {
  const [sub, setSub] = useState('daily');

  const Tab = ({ id, label, icon: Icon }) => (
    <button
      onClick={() => setSub(id)}
      className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition ${
        sub === id ? 'text-white shadow-sm' : 'text-slate-600 hover:bg-slate-100'
      }`}
      style={sub === id ? { background: C.burgundy } : {}}
      data-testid={`admin-subtab-${id}`}
    >
      <Icon className="h-4 w-4" /> {label}
    </button>
  );

  return (
    <div className="space-y-6" data-testid="admin-console">
      <div className="flex flex-wrap gap-2">
        <Tab id="daily" label="Daily Update" icon={ClipboardList} />
        {canConfigure && <Tab id="config" label="Configuration" icon={Settings2} />}
      </div>

      {sub === 'daily' && <AdminDailyUpdate canClose={canConfigure} onAfterClose={onAfterClose} />}
      {sub === 'config' && canConfigure && (
        <AdminSettings
          employees={employees}
          settings={settings}
          isCoreAdmin={isCoreAdmin}
          access={access}
          onChanged={onChanged}
        />
      )}
    </div>
  );
};
